import * as React from 'react';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { Button } from 'src/domains/layouts/webview/components/common/button/Button';
import { RabCloseIconWrapper, YouDecideExitWrapper } from './YouDecideHeaderHref.style';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';

interface PropsType {
    onClick?: (e?: React.SyntheticEvent) => void;
    isYouDecideOpen: boolean;
    variant: DefaultComponentVariantType | null;
}

export const YouDecideHref = ({ onClick, isYouDecideOpen, variant }: PropsType): JSX.Element => {
    if (isYouDecideOpen) {
        return (
            <YouDecideExitWrapper
                onClick={onClick}
                variant={variant}
                data-test='exit-wrapper'
            >
                Exit
                <RabCloseIconWrapper
                    variant={variant}
                    data-test='close-icon'
                />
            </YouDecideExitWrapper>
        );
    }

    return (
        <Button
            size='small'
            onClick={onClick}
            dataTest='bet-builder'
        >
            <I18n
                langKey='you-decide.button.build-bet'
                defaultText='Build-a-Bet'
            />
        </Button>
    );
};
